import { Sparkles } from "lucide-react";

/**
 * AEO-friendly "Key takeaways" box. Renders 3–5 quotable bullets at the top
 * of long-form content so LLMs and skimmers can extract the gist quickly.
 */
export function KeyTakeaways({
  items,
  title = "Key takeaways",
}: {
  items: string[];
  title?: string;
}) {
  const filtered = items.filter(Boolean).slice(0, 5);
  if (filtered.length === 0) return null;
  return (
    <aside
      aria-label={title}
      className="not-prose mt-10 rounded-2xl border border-primary/30 bg-card/60 p-6 lg:p-8"
    >
      <div className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-primary">
        <Sparkles size={14} />
        {title}
      </div>
      <ul className="mt-4 space-y-3">
        {filtered.map((t, i) => (
          <li key={i} className="flex gap-3 text-foreground leading-relaxed">
            <span
              aria-hidden="true"
              className="mt-2 size-1.5 shrink-0 rounded-full bg-primary shadow-[0_0_10px_var(--glow,theme(colors.primary))]"
            />
            <span>{t}</span>
          </li>
        ))}
      </ul>
    </aside>
  );
}